import React, { useMemo } from 'react';
import { Filter, FilterModel } from './';
import { sortBy } from 'lodash';
import { FILTER_ORDER, FILTERS_DEFAULT_OPENED } from '@config/filters';

const Filters = ({ facets = {}, brandModels = {}, setIsFilterInfoModalOpen, setCurrentSelectedFilter }) => {
    /**
     * Compare the facets with the FILTER_ORDER list to create
     * a desired order as specified in the FILTER_ORDER array.
     *
     * @returns {[string, any][]}
     */
    const filterList = useMemo(
        () =>
            Object.entries(facets).sort(([nameA], [nameB]) => {
                const indexA = FILTER_ORDER.indexOf(nameA);
                const indexB = FILTER_ORDER.indexOf(nameB);

                return indexA - indexB;
            }),
        [facets]
    );

    /**
     * Checks if any of the brand options has been selected.
     *
     * @returns {boolean}
     */
    const hasSelectedBrand = useMemo(
        () =>
            facets['Brand']?.options.some(({ selected }) => selected === true),
        [facets]
    );

    return (
        <>
            {filterList.map(([key, value]) => {
                const openedByDefault = FILTERS_DEFAULT_OPENED[key];
                switch (value.name) {
                    case 'IsAdapted': {

                        const options = value.options.sort(function(x, y) {
                            return y.value.localeCompare(x.value);
                        });

                        return (
                            <Filter
                                type={`checkbox`}
                                key={value.name}
                                title={key}
                                options={options}
                                active={openedByDefault}
                                setIsFilterInfoModalOpen={setIsFilterInfoModalOpen}
                                setCurrentSelectedFilter={setCurrentSelectedFilter}
                            />
                        );
                    }
                    case 'Year': {
                        const options = sortBy(value.options, [
                            o => Number(o.value)
                        ]).slice(1);    

                        return (
                            <Filter
                                type={`range`}
                                key={value.name}
                                title={key}
                                options={options}
                                active={openedByDefault}
                                setIsFilterInfoModalOpen={setIsFilterInfoModalOpen}
                                setCurrentSelectedFilter={setCurrentSelectedFilter}
                            />
                        );
                    }
                    case 'Mileage':
                    case 'PriceOnline': {
                        const options = sortBy(value.options, [
                            o => Number(o.value)
                        ]);

                        return (
                            <Filter
                                type={`range`}
                                key={value.name}
                                title={key}
                                options={options}
                                active={openedByDefault}
                                setIsFilterInfoModalOpen={setIsFilterInfoModalOpen}
                                setCurrentSelectedFilter={setCurrentSelectedFilter}
                            />
                        );
                    }
                    case 'Brand': {
                        const options = sortBy(value.options, [
                            o => o.name.normalize('NFKD').replace(/[^\w]/g, '')
                        ]);

                        return (
                            <Filter
                                type={`checkbox`}
                                key={value.name}
                                title={key}
                                options={options}
                                active={openedByDefault}
                                setIsFilterInfoModalOpen={setIsFilterInfoModalOpen}
                                setCurrentSelectedFilter={setCurrentSelectedFilter}
                            />
                        );
                    }
                    case 'ExtraFields.VehiclePurpose':
                    case 'ExtraFields.DrivingOption':
                    case 'ExtraFields.CustomizationOptions':
                    case 'Transmission':
                    case 'ColorNumber':
                    case 'FuelType': {
                        return (
                            <Filter
                                type={`checkbox`}
                                key={value.name}
                                title={key}
                                options={value.options}
                                active={openedByDefault}
                                setIsFilterInfoModalOpen={setIsFilterInfoModalOpen}
                                setCurrentSelectedFilter={setCurrentSelectedFilter}
                            />
                        );
                    }
                    case 'Model': {
                        const options = sortBy(value.options, [
                            o => o.name.normalize('NFKD').replace(/[^\w]/g, '')
                        ]);

                        return (
                            <FilterModel
                                brandModels={brandModels}
                                key={value.name}
                                title={key}
                                options={options}
                                hasSelectedBrand={hasSelectedBrand}
                                active={openedByDefault}
                                setIsFilterInfoModalOpen={setIsFilterInfoModalOpen}
                                setCurrentSelectedFilter={setCurrentSelectedFilter}
                            />
                        );
                    }
                    default:
                        return null;
                }
            })}
        </>
    );
};

export default Filters;
